import _ from "lodash";

import ExternalLogger from "../../../logger/ExternalLogger";
import ModalAccessibility from "../../../util/ModalAccessibility";

import ContactModalController from "./ContactModalController";
import LanguageModalController from "./LanguageModalController";

/**
 *  Deprecated March 12, 2021 - Please make updates in react version
 *
 */

var FooterController = function (
    $rootScope,
    $scope,
    $modal,
    $window,
    $cookies,
    $location,
    $q,
    AcctsCustomizationRetrievalService,
    DefaultAcctsCustRetrievalService,
    DocsLinksService,
    FooterFactory,
    AuthenticationStatusService,
    accountService,
    AccuCodeService,
    $translate,
    LanguageCodeFactory,
    TransactionAccessRetrService
) {
    /**
     * Logger.
     */
    var logger = ExternalLogger.getInstance("ContactModalController");

    $scope.styleEnv = __styleEnv__;
    var modalInstance;
    $scope.docLinks = DocsLinksService;
    $rootScope.phonenumber = {
        planSpecificNum: ""
    };
    $rootScope.isNotClickable = "false";
    $scope.gaId = "";
    $scope.isAuthenticated = false;
    $rootScope.siteContactInfo = {
        beginTime: "",
        endTime: "",
        timeZone: "",
        tdd: "",
        alias: "",
        intlNbr: ""
    };
    $scope.currentYearForFooter = new Date().getFullYear();

    $scope.currentDomain = $location.protocol() + "://" + $location.host();
    if ($window.location.port !== "") {
        $scope.currentDomain += ":" + $window.location.port;
    }

    function processAuthentication(data) {
        function propertyToBoolean(val) {
            var booleanState = ["false", "true"].indexOf(val);
            return booleanState >= 0 ? Boolean(booleanState) : val;
        }

        var authenticationStatus = _.mapValues(data, propertyToBoolean);
        $scope.isAuthenticated = authenticationStatus.authenticated;

        if (authenticationStatus.authenticated) {
            accountService.setActiveGroupAccount().then(function () {
                var activeGroupAccount = accountService.getActiveGroupAccount();
                $scope.gaId = activeGroupAccount.groupId;

                FooterFactory.query({ gaId: $scope.gaId }, function (data) {
                    $rootScope.phonenumber.planSpecificNum = data.phone;
                    $rootScope.siteContactInfo.phone = data.phone;
                    $rootScope.siteContactInfo.beginTime = data.beginTime;
                    $rootScope.siteContactInfo.endTime = data.endTime;
                    $rootScope.siteContactInfo.timeZone = data.timeZone;
                    $rootScope.siteContactInfo.endTime = data.endTime;
                    $rootScope.siteContactInfo.tdd = data.tdd;
                    $rootScope.siteContactInfo.intlNumber = data.intlNumber;
                    $rootScope.siteContactInfo.alias = data.alias;
                    $rootScope.siteContactInfo.email = data.email;

                    if ($rootScope.phonenumber && $rootScope.phonenumber.planSpecificNum !== null) {
                        $rootScope.isNotClickable = "true";
                    }
                });

                processLanguagePreference();
            });
        }
    }

    function processLanguagePreference() {
        var method = "processLanguagePreference";
        var https = "https://";
        var http = "http://";
        var toLangCode = "es";
        var period = ".";
        var currentUrl = $window.location.href;
        var newUrl = currentUrl;
        $translate(["footer.languagePreference.supportLanguagePreference"]).then(
            function (translations) {
                var supportLanguagePreference =
                    translations["footer.languagePreference.supportLanguagePreference"];
                logger.debug("{0} - supportLanguagePreference=[{1}]", [
                    method,
                    supportLanguagePreference
                ]);

                if (supportLanguagePreference !== "true") {
                    return null;
                }

                var activeGroupAccount = accountService.getActiveGroupAccount();
                var txnCodeParamWithGroup = {
                    txnCode: "WNSPWB,WNLANG",
                    individualId: activeGroupAccount.individualId,
                    groupId: activeGroupAccount.groupId
                };

                TransactionAccessRetrService.queryWithAccount(
                    txnCodeParamWithGroup,
                    function (response) {
                        $rootScope.trnsltWbTrnCode = response.WNSPWB && response.WNSPWB === "true";
                        $rootScope.langUpdTrnCode = response.WNLANG && response.WNLANG === "true";

                        if ($rootScope.langUpdTrnCode || $rootScope.trnsltWbTrnCode) {
                            if ($rootScope.langUpdTrnCode) {
                                $scope.authenticatedMessageLabel =
                                    "footer.customerSupport.pstLoginDescriptionWithTrnslt";
                                $rootScope.siteContactInfo.trnsltLabel = $translate.instant(
                                    "footer.languagePreference.linkSpanish"
                                );
                            }
                            LanguageCodeFactory.retrieveLanguageCode.query(
                                {},
                                function (data) {
                                    if (data !== null && data.languageCode) {
                                        $rootScope.siteContactInfo.selectedLanguage =
                                            data.languageCode;
                                        if (
                                            $rootScope.langUpdTrnCode &&
                                            data.languageCode === "SPN"
                                        ) {
                                            $rootScope.siteContactInfo.trnsltLabel =
                                                $translate.instant(
                                                    "footer.languagePreference.linkEnglish"
                                                );
                                        }
                                        var isPaeUser =
                                            data.paeUser === "true" ||
                                            (data.paeUser === "false" ? false : data.paeUser);
                                        if (
                                            $rootScope.trnsltWbTrnCode &&
                                            data.languageCode === "SPN" &&
                                            !isPaeUser
                                        ) {
                                            logger.debug("Redirect to Spanish site...");
                                            if (
                                                currentUrl.indexOf(https + toLangCode) < 0 &&
                                                currentUrl.indexOf(http + toLangCode) < 0 &&
                                                currentUrl.indexOf("participant") >= 0 &&
                                                currentUrl.indexOf("login") < 0
                                            ) {
                                                AuthenticationStatusService.clearSpanishLanguageCookies().then(
                                                    function (resp) {
                                                        logger.info(
                                                            "SSO Spanish cookies have been cleared.",
                                                            resp
                                                        );
                                                        LanguageCodeFactory.setLanguageCookies.query(
                                                            {},
                                                            function (data) {
                                                                logger.info(
                                                                    "SSO Cloned cookies for Spanish site",
                                                                    data
                                                                );
                                                                newUrl = newUrl.replace(
                                                                    https,
                                                                    https + toLangCode + period
                                                                );
                                                                newUrl = newUrl.replace(
                                                                    http,
                                                                    http + toLangCode + period
                                                                );
                                                                logger.info(
                                                                    "Redirect to Spanish site..."
                                                                );
                                                                $window.location.href = newUrl;
                                                            },
                                                            function (error) {
                                                                logger.error(
                                                                    "Failed to clone the cookie for Spanish site",
                                                                    error
                                                                );
                                                            }
                                                        );
                                                    },
                                                    function (error) {
                                                        logger.error(
                                                            "SSO Failed to clearSpanishLanguageCookies",
                                                            error
                                                        );
                                                    }
                                                );
                                            } else {
                                            }
                                        } else if (
                                            currentUrl.indexOf(https + toLangCode) >= 0 ||
                                            currentUrl.indexOf(http + toLangCode) >= 0
                                        ) {
                                            newUrl = currentUrl.replace(
                                                https + toLangCode + period,
                                                https
                                            );
                                            newUrl = newUrl.replace(
                                                http + toLangCode + period,
                                                http
                                            );
                                            logger.info("Redirect to English site...");
                                            $window.location.href = newUrl;
                                        }
                                    } else {
                                        logger.error(
                                            "Failed to get language code of gaId=%s, indId=%s",
                                            activeGroupAccount.groupId,
                                            activeGroupAccount.individualId,
                                            data
                                        );
                                    }
                                },
                                function (error) {
                                    logger.error(
                                        "Failed to get language code of gaId=%s, indId=%s",
                                        activeGroupAccount.groupId,
                                        activeGroupAccount.individualId,
                                        error
                                    );
                                }
                            );
                            if (!$rootScope.siteContactInfo.selectedLanguage) {
                                $rootScope.siteContactInfo.selectedLanguage = "ENG";
                            }
                        }
                        if (
                            !$rootScope.trnsltWbTrnCode &&
                            (currentUrl.indexOf(https + toLangCode) >= 0 ||
                                currentUrl.indexOf(http + toLangCode) >= 0)
                        ) {
                            newUrl = currentUrl.replace(https + toLangCode + period, https);
                            newUrl = newUrl.replace(http + toLangCode + period, http);
                            logger.info("Redirect to English site...");
                            $window.location.href = newUrl;
                        }
                    },
                    function (error) {
                        logger.error(
                            "Failed to check transaction access for WNSPWB, WNLANG of gaId=%s, indId=%s",
                            activeGroupAccount.groupId,
                            activeGroupAccount.individualId,
                            error
                        );
                    }
                );

                var switchAccu = document.cookie.replace(
                    /(?:(?:^|.*;\s*)switchAccu\s*\=\s*([^;]*).*$)|^.*$/,
                    "$1"
                );
                if (switchAccu) {
                    logger.info("Found switchAccu, resetAccu.", switchAccu);
                    var wildCardDomain = $scope.currentDomain;
                    if (wildCardDomain && wildCardDomain.indexOf(toLangCode + period) >= 0) {
                        wildCardDomain = wildCardDomain.replace(https + toLangCode, "");
                        wildCardDomain = wildCardDomain.replace(http + toLangCode, "");
                    } else {
                        wildCardDomain = wildCardDomain.replace(https, ".");
                        wildCardDomain = wildCardDomain.replace(http, ".");
                    }

                    logger.info("footer controller in the switchAccu with accu" + switchAccu);
                    $cookies.remove("accu", { path: "/" });
                    document.cookie =
                        "accu=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
                        wildCardDomain +
                        "; ";
                    $cookies.put("accu", switchAccu, { path: "/" });

                    $cookies.remove("accu", { path: "/participant" });
                    document.cookie =
                        "accu=; path=/participant; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
                        wildCardDomain +
                        "; ";
                    $cookies.put("accu", switchAccu, { path: "/participant" });

                    $cookies.remove("clientAccu", { path: "/" });
                    document.cookie =
                        "clientAccu=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
                        wildCardDomain +
                        "; ";
                    $cookies.put("clientAccu", switchAccu, { path: "/" });

                    $cookies.remove("clientAccu", { path: "/participant" });
                    document.cookie =
                        "clientAccu=; path=/participant; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
                        wildCardDomain +
                        "; ";
                    $cookies.put("clientAccu", switchAccu, { path: "/participant" });

                    $cookies.remove("switchAccu", { path: "/" });
                    document.cookie =
                        "switchAccu=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=" +
                        wildCardDomain +
                        "; ";
                }
            }
        );
    }

    $scope.accuCustomization = {};
    $scope.footer = {};
    $scope.accu = AccuCodeService.getAccuCode();

    $scope.nonAuthenticatedMessageLabel = "footer.customerSupport.preLoginDescription";
    $scope.authenticatedMessageLabel = "footer.customerSupport.pstLoginDescription";

    $scope.getNonAuthenticatedMessage = function () {
        var translationData = $scope.getNonAuthenticatedTranslateValues();
        if (translationData && translationData.timeZone) {
            translationData.timeZoneText = $translate.instant(
                "footer.timeZones." + translationData.timeZone
            );
        }
        return $translate.instant($scope.nonAuthenticatedMessageLabel, translationData);
    };

    $scope.getNonAuthenticatedTranslateValues = function () {
        var data = {
            phone: $rootScope.siteContactInfo.phone,
            begin: $rootScope.siteContactInfo.beginTime,
            end: $rootScope.siteContactInfo.endTime,
            timeZone: $rootScope.siteContactInfo.timeZone,
            alias: $rootScope.siteContactInfo.alias,
            intlNumber: $rootScope.siteContactInfo.intlNumber,
            tdd: $rootScope.siteContactInfo.tdd,
            email: $rootScope.siteContactInfo.email
        };
        //logger.info('getNonAuthTranslateValues',data);
        return data;
    };

    $scope.getAuthenticatedMessage = function () {
        var translationData = $scope.getNonAuthenticatedTranslateValues();
        if (translationData && translationData.timeZone) {
            translationData.timeZoneText = $translate.instant(
                "footer.timeZones." + translationData.timeZone
            );
        }
        return $translate.instant($scope.authenticatedMessageLabel, translationData);
    };

    $scope.getAuthenticatedTranslateValues = function () {
        var data = {
            phone: $rootScope.phonenumber.planSpecificNum,
            begin: $rootScope.siteContactInfo.beginTime,
            end: $rootScope.siteContactInfo.endTime,
            timeZone: $rootScope.siteContactInfo.timeZone,
            alias: $rootScope.siteContactInfo.alias,
            intlNumber: $rootScope.siteContactInfo.intlNumber,
            tdd: $rootScope.siteContactInfo.tdd,
            email: $rootScope.siteContactInfo.email
        };
        //logger.info('getAuthenticatedTranslateValues',data);
        return data;
    };

    $rootScope.$on("siteContactInfoUpdated", function () {
        logger.info("siteContactInfoUpdated - ", $rootScope.siteContactInfo);
        $scope.nonAuthenticatedMessageLabel = $scope.authenticatedMessageLabel;
    });

    function setAccuData(customizations) {
        angular.extend($scope.accuCustomization, customizations);
        angular.extend($scope.footer, customizations.footer);
        $scope.logoUrl = customizations.logoUrl;
        $scope.showGenericLogoPrelogin = customizations.showGenericLogoPrelogin;
    }

    function initCustomizations() {
        $scope.accuCustomization = {};
        $scope.footer = {};
        $scope.accu = AccuCodeService.getAccuCode();
        logger.info(
            "footer-initCustomizations",
            "scope_accu=" + $scope.accu,
            "cookie_accu=" + AccuCodeService.getAccuCode()
        );
        // debugger;
        $q.all([
            AuthenticationStatusService.getAuthData(),
            DefaultAcctsCustRetrievalService.query({}).$promise,
            AcctsCustomizationRetrievalService.query({ accu: $scope.accu }).$promise
        ]).then(function (responses) {
            processAuthentication(_.head(responses));
            _.each(_.tail(responses), setAccuData);
        });
    }

    //showNonAuthHeader will only exist for LOGIN-UI
    // @See LoginUIMasterController where 'showNonAuthHeader' is set.
    if (_.isUndefined($rootScope.showNonAuthHeader)) {
        initCustomizations();
    } else {
        // LOGIN-UI which may log out a participant due to the state being displayed (/login, etc..)
        //  In this case, this logic is intended to delay "initCustomizations" until after it is determined
        //  if the participant should be logged out.
        $rootScope.$on("loginAuthStatusVerified", initCustomizations);
    }

    /**
     * open footer modals
     * source will be sourced from "styleEnv" via ngInclude
     * method used by enrollment landing page; do not remove or comment out
     *
     */
    $scope.openFooterModal = function (modalSrc) {
        logger.debug("openContactModal({0}) : {0}{1}", [
            modalSrc,
            $scope.styleEnv,
            $scope.accuCustomization[modalSrc]
        ]);

        if (!modalSrc) {
            logger.debug("defaulting modalSrc to 'contactModalSrc'");
            modalSrc = "contactModalSrc";
        }

        if ($scope.accuCustomization[modalSrc]) {
            var scope = $scope.$new();
            scope.params = { footer: $scope.footer };
            scope.params = { accuCustomization: $scope.accuCustomization };

            var templateStr =
                "<div ng-include src=\"'" +
                $scope.styleEnv +
                $scope.accuCustomization[modalSrc] +
                "'\"></div>";

            logger.debug("openContactModal : templateStr={2}", [templateStr]);

            modalInstance = $modal.open({
                scope: scope,
                template: templateStr,
                controller:
                    modalSrc === "languageModalSrc"
                        ? LanguageModalController
                        : ContactModalController,
                controllerAs: "ctrl",
                size: "md",
                windowClass: "modal-wrapper"
            });

            modalInstance.result.then(
                function (selectedLanguage) {
                    logger.info("selectedLanguage: " + selectedLanguage);
                    $rootScope.siteContactInfo.selectedLanguage = selectedLanguage;
                    if ($rootScope.siteContactInfo.selectedLanguage == "SPN") {
                        $rootScope.siteContactInfo.trnsltLabel = $translate.instant(
                            "footer.languagePreference.linkEnglish"
                        );
                        if ($rootScope.trnsltWbTrnCode) {
                            AuthenticationStatusService.clearSpanishLanguageCookies().then(
                                function (data) {
                                    logger.info("Spanish cookies have been cleared.", data);
                                },
                                function (error) {
                                    logger.error("Failed to clear Spanish site cookie", error);
                                }
                            );
                        }
                    } else {
                        $rootScope.siteContactInfo.trnsltLabel = $translate.instant(
                            "footer.languagePreference.linkSpanish"
                        );
                    }
                },
                function () {
                    logger.info("Modal dismissed at: " + new Date());
                }
            );

            ModalAccessibility.onOpenModal(".modal-dialog");
        } else {
            logger.info(
                "footer modal invoked without source..nothing to display.  src={0}",
                modalSrc
            );
        }
    };
};

FooterController.$inject = [
    "$rootScope",
    "$scope",
    "$modal",
    "$window",
    "$cookies",
    "$location",
    "$q",
    "AcctsCustomizationRetrievalService",
    "DefaultAcctsCustRetrievalService",
    "DocsLinksService",
    "FooterFactory",
    "AuthenticationStatusService",
    "accountService",
    "AccuCodeService",
    "$translate",
    "LanguageCodeFactory",
    "TransactionAccessRetrService"
];
export default FooterController;
